import type {
  BulkInclusionRule,
  BulkWeightRule,
  InclusionRule,
  KindCondition,
  PriceId,
  WeightValue,
} from '@iheartjane/types';

// Form-state input shape. parseRulesFromApplyTo accepts this loose shape and
// emits the canonical SpecialRulesPayloadFor<T>. List fields are nullable
// because the legacy io-ts SpecialRulesV2 schema permits null on each one.
export type FormInclusion = {
  brand_ids?: number[] | null;
  brands?: string[] | null;
  bulk_weights?: BulkWeightRule[] | null;
  kinds?: KindCondition[] | null;
  lineages?: string[] | null;
  product_ids?: number[] | null;
  weight_values?: WeightValue[] | null;
  weights?: PriceId[] | null;
};

export type FormExclusion = FormInclusion;

type FormProductThreshold = {
  maximum_price?: number | null;
  minimum_price?: number | null;
};

export type FormRules = {
  excludes?: FormExclusion[] | null;
  includes?: FormInclusion[] | null;
  product_threshold?: FormProductThreshold | null;
};

// Backend's InclusionRule and ExclusionRule have identical fields (likewise for
// the bulk-pricing variants), so a single tuple per ruleset is the source of
// truth for which keys parseRulesFromApplyTo allows.
export const RULE_KEYS = [
  'brands',
  'brand_ids',
  'kinds',
  'lineages',
  'product_ids',
  'weights',
  'weight_values',
] as const satisfies ReadonlyArray<keyof InclusionRule>;

export const BULK_PRICING_RULE_KEYS = [
  'brands',
  'brand_ids',
  'bulk_weights',
  'bulk_weight_values',
  'kinds',
  'lineages',
  'product_ids',
] as const satisfies ReadonlyArray<keyof BulkInclusionRule>;
